import { render, staticRenderFns } from "./InterCommDiscRateReview.vue?vue&type=template&id=2a48294b&"
import script from "./InterCommDiscRateReview.vue?vue&type=script&lang=js&"
export * from "./InterCommDiscRateReview.vue?vue&type=script&lang=js&"
import style0 from "./InterCommDiscRateReview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "InterCommDiscRateReview.vue"
export default component.exports